import { computed, ref } from 'vue'
import { getRouter } from '@/router/instance'

// Reactive current URL path. Under the router shell it tracks client-side
// navigations; on per-page mounts it's a static snapshot (the page reloads
// on every navigation anyway).
export function useCurrentUrl() {
  const router = getRouter()
  if (router) return computed(() => router.currentRoute.value.path)

  return ref(window.location.pathname)
}
